import React, {Component} from "react";
import { ScheduleMatrixTable } from './ScheduleMatrixTable';
import * as prosConnect from "../prodect/ProsConnect";
import {
    getEndOfWorkingDayTime,
    getNumberOfWeek, stateIcons,
    getThisWeekMonday, SidePanel, renderObsAttachments, AddObsButton
} from "../prodect/ProsCommonUi";
import {prosNotificationShow, prosPopupOpenDynamic, prosPopupRender} from "../prodect/ProsPopup";
import ProsDate from "../prodect/ProsDate";
import {
    ATTR_OBJ_STATE, ATTR_PARENT_OBS,
    getActiveProject, getMonotonicTimeMs,
    OBJ_STATE_TO_DEL,
    STR_NO_VALUE,
    VIEW_MODE_CALENDAR, VIEW_MODE_KANBAN, OBS_LIST, OBS_OBJ_LIST, ATTR_EXPIRATION, ATTR_OBJ_ID, ATTR_OBJ_TYPE,
    OBJ_TYPE_ITM_OBS, currentTimeMs, ATTR_SORT_ORDER_I, ATTR_CREATED_MS_I,
    STR_NO
} from "../prodect/ProsConnect";

import RenderReport from "./RenderReport";
import {setHelpContext} from "../prodect/HelpManager";
import {getCopyMoveManager} from "../prodect/CopyMoveManager";
import {prosPopupClose, prosPopupOpen} from "../prodect/ProsPopup";
import DropdownMenu from "../components/DropdownMenu";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import Spacer from "../components/Spacer";
import RadioButton from "../components/RadioButton";
import ToggleSwitch from "../components/ToggleSwitch";
import {getFilterText} from "./ProjectReports";

const MONTHS_IN_QUARTAL = 3;
const DAYS_IN_WEEK = 7;
const WEEKS_IN_MONTH = 4;
const WEEKS_IN_YEAR = 52;
const WEEK_DAY_FRIDAY = 4;
const HOUR_START_OF_DAY = 6;

const TIME_OFFSET_MS = 1000;

const MONTH_TO_QVARTAL =
    {   0: 1,   1: 1,   2: 1,
        3: 2,   4: 2,   5: 2,
        6: 3,   7: 3,   8: 3,
        9: 4,   10: 4,  11: 4,
    }

const COL_CHANGE_DECREMENT = "dec"
const COL_CHANGE_INCREMENT = "inc"
const COL_CHANGE_RESET     = "reset"

const SCHED_INTERVAL_YEAR = "interval_year";
const SCHED_INTERVAL_QUARTAL = "interval_quartal";
const SCHED_INTERVAL_MONTH = "interval_month";
const SCHED_INTERVAL_WEEK = "interval_week";
const SCHED_INTERVAL_DAY = "interval_day";
const DEFAULT_SCHED_INTERVAL = SCHED_INTERVAL_WEEK;
const SPECIAL_TAG_REPORT = 'REPORTS';
const SPECIAL_TAG_REPORT_IND = -1;

const SCHED_INTERVALS = [
    SCHED_INTERVAL_DAY, SCHED_INTERVAL_WEEK, SCHED_INTERVAL_MONTH,
    SCHED_INTERVAL_QUARTAL, SCHED_INTERVAL_YEAR,
    ];

const SETTINGS_YEAR_COLS = {
    title: "Vuosi",
    curr: 2, DEFAULT: 2,  MIN: 1,  MAX: 6,
    next: SCHED_INTERVAL_YEAR, prev: SCHED_INTERVAL_QUARTAL, stepDays: WEEKS_IN_YEAR*DAYS_IN_WEEK
};

const SETTINGS_QUARTAL_COLS = {
    title: "Kvartaali",
    curr: 4, DEFAULT: 4,  MIN: 1,  MAX: 8,
    next: SCHED_INTERVAL_YEAR, prev: SCHED_INTERVAL_MONTH, stepDays: WEEKS_IN_MONTH*MONTHS_IN_QUARTAL*DAYS_IN_WEEK
};

const SETTINGS_MONTH_COLS = {
    title: "Kuukausi",
    curr: 3, DEFAULT: 3,  MIN: 2,  MAX: 14,
    next: SCHED_INTERVAL_QUARTAL, prev: SCHED_INTERVAL_WEEK, stepDays: WEEKS_IN_MONTH*DAYS_IN_WEEK
};

const SETTINGS_WEEK_COLS = {
    title: "Viikko",
    curr: 4, DEFAULT: 4,  MIN: 2,  MAX: 16, SHORT_AFTER: 8,
    next: SCHED_INTERVAL_MONTH, prev: SCHED_INTERVAL_DAY, stepDays: DAYS_IN_WEEK
};

const SETTINGS_DAY_COLS = {
    title: "Päivä",
    curr: 7, DEFAULT: 7,  MIN: 2,  MAX: 31, SHORT_AFTER: 7,
    next: SCHED_INTERVAL_WEEK, prev: SCHED_INTERVAL_DAY, stepDays: 1
};

const LOCAL_STORAGE_MATRIX_SETTINGS_PREFIX = 'Prodect-TM-';
const LOCAL_STORAGE_KANBAN_SETTINGS_PREFIX = 'Prodect-TM-Kanban-';

// Prodect Guidelines:
//      - handle props change from parent https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html
//      - keep in 'state' those parameters that need to trigger render
//      - internal calculated parameters in class attributes to avoid double render by post state actions
//      - use refreshUi() to re-render when gen an update from prosConnect

const WEEK_DAY_NAMES = ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"];
const MONTH_NAMES = ["Tammi", "Helmi", "Maalis", "Huhti", "Touko", "Kesä",
                    "Heinä", "Elo", "Syys", "Loka", "Marras", "Joulu"];

export const scheduleMatrixViewModeType = {
    NORMAL_ITEMS: "normalItems",
    OVERVIEW_ITEMS: "overviewItems",
    OVERVIEW_GROUPS: "overviewGroups",
};

function storageKey(projectId) {
    return LOCAL_STORAGE_MATRIX_SETTINGS_PREFIX + projectId;
}

function storageKeyKanban(projectId) {
    return LOCAL_STORAGE_KANBAN_SETTINGS_PREFIX + projectId;
}

export function saveMatrixSettings(projectId, uiSettings) {
    // Override settings from shared project web link - uiSettings restored from server
    localStorage.setItem(storageKey(projectId), JSON.stringify(uiSettings))
}

export function saveMatrixSettingsKanban(projectId, uiSettings) {
    // Override settings from shared project web link - uiSettings restored from server
    localStorage.setItem(storageKeyKanban(projectId), JSON.stringify(uiSettings))
}

export function restoreMatrixSettings(projectId) {
    let settingsStr = localStorage.getItem(storageKey(projectId))
    if (!settingsStr) {
        return undefined
    }
    return JSON.parse(settingsStr)
}

export function restoreMatrixSettingsKanban(projectId) {
    let settingsStr = localStorage.getItem(storageKeyKanban(projectId))
    if (!settingsStr) {
        return undefined
    }
    return JSON.parse(settingsStr)
}

let maySendPdf = false
export function maySendCalendarPdf() {
    return maySendPdf
}

let cbResetSettings = undefined
export function restoreMatrixUiSettings() {
    if (cbResetSettings) {
        cbResetSettings()
    }
}


export default class ScheduleMatrix extends Component {

    draggingObs = undefined

    constructor(props) {
        super(props)
        this.state = {
            showSidepanel: false,
            selectedObsId: undefined,
            selectedExpireTimeMs: undefined,
            selectedRow: undefined,
            chosenObsList: [],
            isCopyMode: false,
            selectedObsToDrag: [],
            selectedObsGroupId: undefined,
            showPrevNextHistory: false,
            useCreationDate: false,
            showBottomPanel: false,
        }
        this.viewMode = this.props.viewMode

        this.scheduleMatrixTimeColumns = [];
        this.timeOffsetSameDayMs = 0;
        this.kanbanMatrixColumns = [];
        this.kanbanColumnOthers = undefined;

        this.actors = undefined;
        this.uiActorList = undefined;       // list of actor (row) which has each list of tasks (columns)

        this.columns = undefined;
        this.prevSettingsStr = undefined;

        this.chosenTagIndex = undefined;
        this.chosenTagIndexForColumns = undefined;
        this.chosenTag = undefined;
        this.chosenTagForColumns = undefined;
        this.chosenTagOptions = undefined; // This is only for columns
        this.hideRow = undefined;
        this.chosenBgIndex = undefined;
        this.chosenBg = undefined;
        this.scheduleMatrixInterval = DEFAULT_SCHED_INTERVAL;
        this.scheduleMatrixViewMode = scheduleMatrixViewModeType.NORMAL_ITEMS
        this.useCreationDate = undefined

        this.columnDefs = {};
        this.columnDefs[SCHED_INTERVAL_YEAR] = SETTINGS_YEAR_COLS;
        this.columnDefs[SCHED_INTERVAL_QUARTAL] = SETTINGS_QUARTAL_COLS;
        this.columnDefs[SCHED_INTERVAL_MONTH] = SETTINGS_MONTH_COLS;
        this.columnDefs[SCHED_INTERVAL_WEEK] = SETTINGS_WEEK_COLS;
        this.columnDefs[SCHED_INTERVAL_DAY] = SETTINGS_DAY_COLS;

        this.needRecalculate = false;
        this.reportCountWithObs = 0;
        this.matrixBrowsingTime = getThisWeekMonday(new Date(), HOUR_START_OF_DAY)
        this.projectId = undefined

        this.notifFromReport = this.notifFromReport.bind(this);
        this.gotoPage = this.gotoPage.bind(this);
        cbResetSettings =()=> this.restoreSettings(prosConnect.getActiveProject())
    }

    componentDidMount() {
        this.restoreSettings(prosConnect.getActiveProject())
        this.refreshUi()
        prosConnect.registerToRetrieveViewSettings(VIEW_MODE_CALENDAR, (projectId)=>this.retrieveViewSettings(projectId))
    }

    componentWillUnmount() {
        this.saveSettings(this.projectId)
        maySendPdf = false
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.viewMode !== this.props.viewMode) {
            this.restoreSettings(prosConnect.getActiveProject())
            this.viewMode = this.props.viewMode
        }
        if (this.props.activeProjectId !== prevProps.activeProjectId) {
            this.setState({showSidepanel: false})
        }
        if (prevProps.uiListRefreshed !== this.props.uiListRefreshed) {
            this.refreshUi()
        }
        if (prevProps.selectedObsId !== this.props.selectedObsId) {
            let obs = prosConnect.findObsById(this.props.selectedObsId)
            this.openSidepanel(obs)
        }
        this.updateMaySendPdf()
    }

    updateMaySendPdf() {
        maySendPdf = this.props.uiList.length > 0 &&
            this.scheduleMatrixViewMode === scheduleMatrixViewModeType.OVERVIEW_GROUPS
    }

    retrieveViewSettings(projectId) {
        this.saveSettings(this.projectId)
        if (this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN) {
            let uiSettings = restoreMatrixSettingsKanban(projectId)
            if (uiSettings) {
                uiSettings.viewMode = VIEW_MODE_KANBAN
            }
            return uiSettings
        }
        let uiSettings = restoreMatrixSettings(projectId)
        if (uiSettings) {
            uiSettings.viewMode = VIEW_MODE_CALENDAR
        }
        return uiSettings
    }

    restoreSettings(project) {
        if (!project) {
            return;
        }
        this.projectId = prosConnect.getActiveProject().getPid()
        let settings
        if (this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN) {
            this.prevSettingsStr = localStorage.getItem(storageKeyKanban(this.projectId))
            settings = restoreMatrixSettingsKanban(this.projectId)
        } else {
            this.prevSettingsStr = localStorage.getItem(storageKey(this.projectId))
            settings = restoreMatrixSettings(this.projectId)
        }
        if (settings) {
            if (settings.chosenTag === SPECIAL_TAG_REPORT) {
                this.chosenTagIndex = SPECIAL_TAG_REPORT_IND;
            } else {
                this.chosenTagIndex = project.tagIdToIndex(settings.chosenTag);
            }
            if (settings.chosenTagForColumns === SPECIAL_TAG_REPORT) {
                this.chosenTagIndexForColumns = SPECIAL_TAG_REPORT_IND;
            } else {
                this.chosenTagIndexForColumns = project.tagIdToIndex(settings.chosenTagForColumns);
            }
            this.chosenBgIndex = project.tagIdToIndex(settings.chosenBg);
            if (settings.scheduleMatrixInterval && SCHED_INTERVALS.includes(settings.scheduleMatrixInterval)) {
                this.scheduleMatrixInterval = settings.scheduleMatrixInterval;
                SCHED_INTERVALS.forEach( key => {
                    let interval_key = key + '_interval';
                    if (settings[interval_key]) {
                        this.columnDefs[key].curr = settings[interval_key];
                    }
                })
            }
            if (settings.timeSavedMs && settings.savedBrowsingTime) {
                this.matrixBrowsingTime = new Date(settings.savedBrowsingTime)
            }
            this.scheduleMatrixTimeColumns = settings.scheduleMatrixTimeColumns;
            this.kanbanColumnOthers = settings.kanbanColumnOthers
            this.chosenTagOptions = settings.chosenTagOptions
            this.hideRow = settings.hideRow
            this.scheduleMatrixViewMode = settings.scheduleMatrixViewMode ?? this.scheduleMatrixViewMode
            this.useCreationDate = settings.useCreationDate
        }
        let tags = project.getRbTags();
        if (this.chosenTagIndex === undefined) {
            // Default row by 2nd TAG
            this.chosenTagIndex = tags.length > 1 ? 1 : 0;
        }
        if (this.chosenTagIndexForColumns === undefined) {
            // Default column by 1st TAG
            this.chosenTagIndexForColumns = 0
        }
        if (this.chosenBgIndex === undefined) {
            // Default BG color based on 1st TAG which is normally State
            this.chosenBgIndex = 0
        }
        this.kanbanColumnOthers = this.kanbanColumnOthers === undefined ? true : this.kanbanColumnOthers
        this.hideRow = this.hideRow === undefined ? true : this.hideRow
        this.chosenTag = this.chosenTagIndex <= SPECIAL_TAG_REPORT_IND ? SPECIAL_TAG_REPORT : tags[this.chosenTagIndex];
        this.chosenTagForColumns = this.chosenTagIndexForColumns <= SPECIAL_TAG_REPORT_IND ? SPECIAL_TAG_REPORT : tags[this.chosenTagIndexForColumns];
        this.chosenTagOptions = this.chosenTagOptions === undefined ? this.getColumnOptions().map(option => option.index) : this.chosenTagOptions
        this.chosenBg = tags[this.chosenBgIndex];
        // Restore settings #2.604
        this.setState({useCreationDate: !!settings?.useCreationDate})
    }

    saveSettings(projectId) {
        let settings = {
            chosenTag: this.chosenTag,
            chosenTagForColumns: this.chosenTagForColumns,
            kanbanColumnOthers: this.kanbanColumnOthers,
            chosenTagOptions: this.chosenTagOptions,
            hideRow: this.hideRow,
            useCreationDate: this.useCreationDate,
            chosenBg: this.chosenBg,
            scheduleMatrixViewMode: this.scheduleMatrixViewMode,
            scheduleMatrixInterval: this.scheduleMatrixInterval,
            scheduleMatrixTimeColumns: this.scheduleMatrixTimeColumns,
            timeSavedMs: currentTimeMs(),
            savedBrowsingTime: this.matrixBrowsingTime.getTime(),
            // Save all settings #2.604
            filterText: getFilterText(),
        };
        SCHED_INTERVALS.forEach(key => {
            let interval_key = key + '_interval';
            settings[interval_key] = this.columnDefs[key].curr;
        })
        if (this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN) {
            let settingsStr = JSON.stringify(settings);
            if (settingsStr !== this.prevSettingsStr) {
                localStorage.setItem(storageKeyKanban(projectId), settingsStr);
            }
            return
        }
        let settingsStr = JSON.stringify(settings);
        if (settingsStr !== this.prevSettingsStr) {
            localStorage.setItem( storageKey(projectId), settingsStr);
        }
    }

    // After adding creation date option "expirationMs" can actually be creationMs
    getColumnTimeTitle(startPeriod, endPeriod, schedType) {
        let eofDay = getEndOfWorkingDayTime(endPeriod);
        let columnTitle;
        let year = eofDay.getFullYear().toString();
        let columnDef = this.columnDefs[schedType];
        let shortenTitleAfter = columnDef.SHORT_AFTER ?? columnDef.MAX
        switch (schedType) {
            case SCHED_INTERVAL_YEAR:
                columnTitle = '' + year;
                break;
            case SCHED_INTERVAL_QUARTAL:
                let quartal = MONTH_TO_QVARTAL[eofDay.getMonth()];
                columnTitle = 'Q' + quartal + " / " + eofDay.getFullYear();
                break;
            case SCHED_INTERVAL_MONTH:
                let nameOfMonth = MONTH_NAMES[eofDay.getMonth()];
                columnTitle = '' + nameOfMonth + "-" + year;
                break;
            case SCHED_INTERVAL_WEEK:
                let monday = getEndOfWorkingDayTime(getThisWeekMonday(endPeriod, HOUR_START_OF_DAY));
                let monthStr = (monday.getMonth() + 1).toString()
                let yearStr = monday.getFullYear().toString()
                let week = getNumberOfWeek(eofDay).toString()
                columnTitle = columnDef.curr > shortenTitleAfter ?
                    week + " (" + monthStr + "/-" + yearStr.substr(2) + ")"
                    :
                    'vko ' + week + " (" + monthStr + "/" + yearStr + ")"
                break;
            case SCHED_INTERVAL_DAY:
                let month = eofDay.getMonth() + 1;
                let day = eofDay.getDate();
                let nameOfDay = WEEK_DAY_NAMES[eofDay.getDay()];
                columnTitle = columnDef.curr > shortenTitleAfter ?
                    " " + [day, month].join('.') + '-' + year.substr(2) // 21.12-23
                    :
                    nameOfDay + " " + [day, month, year].join('.')      // Mon 21.12.2023
                break;
            default:
                throw new Error("Invalid sched interval " + schedType);
        }
        return {
            columnTitle: columnTitle,                       // unique in visible UI view
            columnKey: columnTitle,              // unique time key for match
            expirationMs: eofDay.getTime(),      // cell ref to set expiration or create new OBS
            startOfPeriod: startPeriod.getTime()   // ref time start of week for column selection
        }
    }

    calculateTableColumns() {
        // when table columns refreshed/changed, save settings per change
        this.saveSettings(this.projectId);
        if (this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN) {
            this.makeMatrixColumnsForKanban()
            this.makeKanbanMatrixObs()
            return
        }
        this.setMatrixColmns();
        this.makeScheduleMatrixObs()
    }

    changeTagIndex(self, i, column = false) {
        let project = prosConnect.getActiveProject();
        if (column) {
            if (self.chosenTagIndexForColumns === i) { return }
            if (self.chosenTagIndex === i) {
                self.chosenTagIndex = self.chosenTagIndexForColumns
            }
            self.chosenTagIndexForColumns = i;
        } else {
            // Row
            if (self.chosenTagIndex === i) { return }
            if (self.chosenTagIndexForColumns === i) {
                self.chosenTagIndexForColumns = self.chosenTagIndex
            }
            self.chosenTagIndex = i;
            self.hideRow = false
        }
        if (self.chosenTagForColumns <= SPECIAL_TAG_REPORT_IND) {
            self.chosenTagForColumns = SPECIAL_TAG_REPORT;
        } else {
            self.chosenTagForColumns = project.tagIndexToId(self.chosenTagIndexForColumns);
        }
        if (self.chosenTagIndex <= SPECIAL_TAG_REPORT_IND) {
            self.chosenTag = SPECIAL_TAG_REPORT;
        } else {
            self.chosenTag = project.tagIndexToId(self.chosenTagIndex);
        }

        if (column) {
            self.chosenTagOptions = self.getColumnOptions().map(option => option.index)
        }
        self.refreshUi()
    }

    chooseTagOption(self, i) {
        if (self.chosenTagOptions.indexOf(i) <= -1) {
            self.chosenTagOptions.push(i)
        } else {
            self.chosenTagOptions.splice(self.chosenTagOptions.indexOf(i), 1)
        }
        self.refreshUi()
    }

    changeBgIndex(self, i) {
        if (self.chosenBgIndex === i) return
        let project = prosConnect.getActiveProject()
        self.chosenBgIndex = i;
        self.chosenBg = project.tagIndexToId(i)
        self.refreshUi()
    }

    notifFromReport(text, type, dismissByUser) {
        prosNotificationShow(this, text, type, dismissByUser)
    }

    refreshUi =()=> {
        this.calculateTableColumns()
        this.setState({refreshCounter: this.state.refreshCounter + 1});
    }

    makeScheduleMatrixObs() {
        this.actors = this.getActors();
        let actorTasks = this.getActorsAndTasks(this.actors);
        this.uiActorList = this.sortTasksList(actorTasks);
        this.makeScheduleMatrixColumns();
    }

    makeKanbanMatrixObs() {
        this.actors = this.getActors(true);
        this.uiActorList = this.getActorsAndTasks(this.actors, true);
        this.makeKanbanColumns();
    }

    expirationValue(obs) {
        if (!obs.hasOwnProperty(ATTR_EXPIRATION) || obs[ATTR_EXPIRATION] === STR_NO_VALUE) {
            return 0
        }
        return obs[ATTR_EXPIRATION]
    }

    creationValue(obs) {
        if (!obs.hasOwnProperty(ATTR_CREATED_MS_I) || obs[ATTR_CREATED_MS_I] === STR_NO_VALUE) {
            return 0
        }
        return obs[ATTR_CREATED_MS_I]
    }

    sortTasksList(list) {
        for (let i in list) {
            if (list[i].tasks.length) {
                list[i].tasks.sort((a, b) => {
                    if (this.useCreationDate) {
                        return this.creationValue(a) - this.creationValue(b)
                    }
                    return this.expirationValue(a) - this.expirationValue(b)
                })
            }
        }
        return list;
    }

    getActors(kanban = false) {
        let project = prosConnect.getActiveProject();
        let rbTagTitlesList = [];
        if (kanban && this.hideRow) {
            return [{
                actor: 0,
                ui_actor: 'no_row',
                tasks: [],
            }]
        }
        if (this.chosenTagIndex <= SPECIAL_TAG_REPORT_IND) {
            // Rows / actors by reports
            let reports = project.getReports()
            reports
                .filter(report =>
                    getActiveProject().isReportSelected(report[ATTR_OBJ_ID])
                    || this.props.showingSearchList)
                .forEach((report, index) => {
                let reportName = prosConnect.getReportInfo(report);
                rbTagTitlesList.push({
                    actor: index,
                    ui_actor: reportName,
                    tasks: [],
                    reportId: report[ATTR_OBJ_ID]
                })
            })
        } else {
            // Rows / Actors by multiselect TAG options
            let mvTag = project.getMvTagSettings(this.chosenTagIndex)
            if (mvTag) {
                mvTag.options.forEach(option => {
                    if (option.inUse)
                        rbTagTitlesList.push({
                            actor: option.optionIndex,
                            ui_actor: option.label,
                            tasks: [],
                        })
                });
                //Ei Tekijää
                rbTagTitlesList.push({
                    actor: rbTagTitlesList.length,
                    ui_actor: "(Puuttuu)",
                    tasks: [],
                })
            }
        }
        return rbTagTitlesList;
    }

    getActorsAndTasks(actorTasks, kanban = false) {
        let lastIndex = actorTasks.length - 1;
        this.reportCountWithObs = 0;
        this.props.uiList.forEach(report => {
            if (report.hasOwnProperty(OBS_LIST) && report[OBS_LIST].length) {
                this.reportCountWithObs++;
                report[OBS_LIST]
                    .filter(obs => prosConnect.isObservation(obs) && (this.useCreationDate || kanban || prosConnect.getExpiration(obs)))
                    .forEach(obs => {
                        if (kanban && this.hideRow) {
                            actorTasks[0].tasks.push(obs)
                            return
                        }
                        let sameActorIndex;
                        if (this.chosenTagIndex <= SPECIAL_TAG_REPORT_IND) {
                            // Rows / actors by reports - OBS belonging to report has same obj id prefix
                            sameActorIndex = actorTasks.findIndex(report => (obs[ATTR_OBJ_ID].indexOf(report.reportId) === 0));
                        } else {
                            // Rows / Actors by multiselect TAG options
                            sameActorIndex = actorTasks.findIndex(item => (item.actor.toString()) === (obs[this.chosenTag]));
                        }
                        if (sameActorIndex > -1) {
                            actorTasks[sameActorIndex].tasks.push(obs);
                        } else {
                            if (lastIndex >= 0) {
                                actorTasks[lastIndex].tasks.push(obs);
                            }
                        }
                    })
            }
        });
        return actorTasks;
    }

    setMatrixColmns() {
        switch (this.scheduleMatrixInterval) {
            case SCHED_INTERVAL_DAY:
                this.makeDayColumns();
                break;
            case SCHED_INTERVAL_WEEK:
                this.makeWeekColumns();
                break;
            case SCHED_INTERVAL_MONTH:
                this.makeMonthColumns();
                break;
            case SCHED_INTERVAL_QUARTAL:
                this.makeQuartalColumns();
                break;
            case SCHED_INTERVAL_YEAR:
                this.makeYearColumns();
                break;
            default:
                break
        }
    }

    makeMatrixColumnsForKanban() {
        let project = prosConnect.getActiveProject();
        let mvTagSettings = project.getMvTagSettings(this.chosenTagIndexForColumns)
        let columns = []
        let tagOptionIds = []
        if ( ! mvTagSettings) {
            this.kanbanMatrixColumns = []
            return
        }
        mvTagSettings.options.forEach((option) => {
            if (this.chosenTagOptions.length <= 0 || this.chosenTagOptions.indexOf(option.optionIndex) !== -1) {
                columns.push({
                    columnTitle: option.label,    // unique in visible UI view
                    columnKey: option.optionIndex.toString() + option.label,     // unique key
                    tagOptionIds: [option.optionIndex],      // tag option id to create new obs with same id
                    tagId: this.chosenTagForColumns,
                    otherColumn: false,
                })
                tagOptionIds.push(option.optionIndex)
            }
        })

        if (this.kanbanColumnOthers) {
            let otherIndexes = mvTagSettings.options
                .filter(option => tagOptionIds.indexOf(option.optionIndex) < 0)
                .map(option => option.optionIndex)
            columns.push({
                columnTitle: 'Muut',    // unique in visible UI view
                columnKey: 'muut',     // unique key
                tagOptionIds: otherIndexes,      // tag option id to create new obs with same id
                tagId: this.chosenTagForColumns,
                otherColumn: true,
            })
        }

        this.kanbanMatrixColumns = columns;
    }

    makeDayColumns() {
        let startPeriod = new Date(this.matrixBrowsingTime)
        let columns = [];
        let columnDef = this.columnDefs[SCHED_INTERVAL_DAY];
        let curr = getEndOfWorkingDayTime(this.matrixBrowsingTime);
        for (let i = 0; i < columnDef.curr; i++) {
            columns.push(this.getColumnTimeTitle(startPeriod, curr, this.scheduleMatrixInterval));
            curr.setDate(curr.getDate() + 1);
            startPeriod.setDate(startPeriod.getDate() + 1);
        }
        this.scheduleMatrixTimeColumns = columns;
    }

    makeWeekColumns() {
        let startPeriod = new Date(this.matrixBrowsingTime)
        let columns = [];
        let columnDef = this.columnDefs[SCHED_INTERVAL_WEEK];
        let curr = getEndOfWorkingDayTime(this.matrixBrowsingTime);
        curr.setDate(curr.getDate() + WEEK_DAY_FRIDAY);
        for (let i = 0; i < columnDef.curr; i++) {
            columns.push(this.getColumnTimeTitle(startPeriod, curr, SCHED_INTERVAL_WEEK));
            curr.setDate(curr.getDate() + columnDef.stepDays);
            startPeriod.setDate(startPeriod.getDate() + columnDef.stepDays);
        }
        this.scheduleMatrixTimeColumns = columns;
    }

    makeMonthColumns() {
        let columns = [];
        let columnDef = this.columnDefs[SCHED_INTERVAL_MONTH];
        let curr = new Date(this.matrixBrowsingTime);
        for (let i = 0; i < columnDef.curr; i++) {
            let startPeriod = new Date(curr.getFullYear(), curr.getMonth() + i, 1);
            startPeriod.setHours(HOUR_START_OF_DAY, 0, 0);
            let lastDayOfMonth = new Date(startPeriod.getFullYear(), startPeriod.getMonth() + 1, 1);
            lastDayOfMonth.setDate(lastDayOfMonth.getDate()-1);
            columns.push(this.getColumnTimeTitle(startPeriod, lastDayOfMonth, SCHED_INTERVAL_MONTH));
        }
        this.scheduleMatrixTimeColumns = columns;
    }

    makeQuartalColumns() {
        let columns = [];
        let columnDef = this.columnDefs[SCHED_INTERVAL_QUARTAL];
        let startPeriod = new Date(this.matrixBrowsingTime);
        let refMonth = 0;   // Q1
        if (startPeriod.getMonth() > 2 && startPeriod.getMonth() < 6) { refMonth = 3; }   // Q2
        if (startPeriod.getMonth() > 5 && startPeriod.getMonth() < 9) { refMonth = 6; }   // Q3
        if (startPeriod.getMonth() > 8) { refMonth = 9; }   // Q4
        startPeriod.setMonth(refMonth);
        startPeriod.setDate(1);
        startPeriod.setHours(HOUR_START_OF_DAY);
        for (let i = 0; i < columnDef.curr; i++) {
            let firstDayOfQuartal = new Date(startPeriod);
            for (let i =0; i < MONTHS_IN_QUARTAL; i++) {
                startPeriod.setMonth(startPeriod.getMonth() + 1);
            }
            let lastDayOfQuartal = new Date(startPeriod);
            lastDayOfQuartal.setDate(lastDayOfQuartal.getDate()-1);
            columns.push(this.getColumnTimeTitle(firstDayOfQuartal, lastDayOfQuartal, SCHED_INTERVAL_QUARTAL));
        }
        this.scheduleMatrixTimeColumns = columns;
    }

    makeYearColumns() {
        let columns = [];
        let columnDef = this.columnDefs[SCHED_INTERVAL_YEAR];
        let startPeriod = new Date(this.matrixBrowsingTime);
        startPeriod.setMonth(0);
        startPeriod.setDate(1);
        startPeriod.setHours(HOUR_START_OF_DAY, 0, 0);
        for (let i = 0; i < columnDef.curr; i++) {
            let lastDayOfYear = new Date(startPeriod.getFullYear(), 11, 31);
            columns.push(this.getColumnTimeTitle(startPeriod, lastDayOfYear, SCHED_INTERVAL_YEAR));
            startPeriod.setFullYear(startPeriod.getFullYear()+1);
        }
        this.scheduleMatrixTimeColumns = columns;
    }

    changeBrowsingTime(days, forward) {
        if (days === 0) {
            // goto "today"
            this.matrixBrowsingTime = new Date();
        } else {
            this.matrixBrowsingTime.setDate(this.matrixBrowsingTime.getDate() + (forward ? days : -days));
        }
        this.refreshUi();
    }

    moveTimeForwards(isForward, fast=false) {
        let columnDef = this.columnDefs[this.scheduleMatrixInterval];
        // save current leftmost time column
        let prevLeftColumnTitle = this.scheduleMatrixTimeColumns[0].columnTitle;
        let numOfDays = columnDef.stepDays;
        if(fast){
            numOfDays *= columnDef.curr; // increase as much as seen in the current view
        }
        this.changeBrowsingTime(numOfDays, isForward);
        while (prevLeftColumnTitle === this.scheduleMatrixTimeColumns[0].columnTitle) {
            // continue change one week at a time until time titles been changed
            this.changeBrowsingTime(DAYS_IN_WEEK, isForward);
        }
    }

    // Column clicked to "zoom time scale"
    // set time starting from selected column and set time interval shorter (prev)
    // example month -> week, week -> day etc
    onTimeColumnClicked(timeColumn){
        return (e) => {
            //Go back (up in time) with SHIFT+click key, and
            //Go forwad (down in time) with a click
            if (e.shiftKey && this.scheduleMatrixInterval !== this.columnDefs[this.scheduleMatrixInterval].next) {
                this.scheduleMatrixInterval = this.columnDefs[this.scheduleMatrixInterval].next;
                this.matrixBrowsingTime = getThisWeekMonday(new Date(timeColumn.startOfPeriod), HOUR_START_OF_DAY);
            } else if (!e.shiftKey && this.scheduleMatrixInterval !== this.columnDefs[this.scheduleMatrixInterval].prev) {
                this.scheduleMatrixInterval = this.columnDefs[this.scheduleMatrixInterval].prev;
                this.matrixBrowsingTime = getThisWeekMonday(new Date(timeColumn.startOfPeriod), HOUR_START_OF_DAY);
            } else {
                this.matrixBrowsingTime = new Date(timeColumn.startOfPeriod);
            }
            if (this.scheduleMatrixInterval !== SCHED_INTERVAL_DAY &&
                this.scheduleMatrixInterval !== SCHED_INTERVAL_WEEK &&
                !(this.scheduleMatrixInterval === SCHED_INTERVAL_YEAR && e.shiftKey)) {
                this.moveTimeForwards(true);
            }
            this.refreshUi();
        };
    }

    // Highlight current / today with accent color
    renderColumnHeader(timeColumn) {
        let today = new Date()
        let todayColTitle = this.getColumnTimeTitle(today, today, this.scheduleMatrixInterval);
        let columnDecorration = (todayColTitle.columnKey === timeColumn.columnKey ? "schedule-matrix-table-column" : "");

        return (<p
            className={columnDecorration}
            onClick={this.onTimeColumnClicked(timeColumn)}
        >{timeColumn.columnTitle}</p>);
        // return <p>{timeColumn.columnTitle}</p>
    }

    renderTimeLookoutCell(row, isBefore){
        const project = prosConnect.getActiveProject();
        const lookoutTimeColumn = isBefore
            ? this.scheduleMatrixTimeColumns[0]
            : this.scheduleMatrixTimeColumns[this.scheduleMatrixTimeColumns.length - 1];
        const tasks = row.original.tasks;
        let filteredTasksList = tasks.filter((itm) => {
            // After adding creation date option "expirationMs" can be creationMs
            let expirationMs
            if (this.useCreationDate) {
                expirationMs = prosConnect.getCreation(itm)
            } else {
                expirationMs = prosConnect.getExpiration(itm)
            }
            if (!expirationMs) {
                return false;
            }
            let itemExpireDate = new Date(parseInt(expirationMs));
            let itemTimeTitle = this.getColumnTimeTitle(itemExpireDate, itemExpireDate, this.scheduleMatrixInterval);
            if (isBefore && itemTimeTitle.columnKey !== lookoutTimeColumn.columnKey &&
                 itemTimeTitle.expirationMs < lookoutTimeColumn.startOfPeriod) {
                return true;
            }
            else if (!isBefore && itemTimeTitle.columnKey !== lookoutTimeColumn.columnKey &&
                 itemTimeTitle.expirationMs > lookoutTimeColumn.expirationMs) {
                return true;
            }
            return false;
        });

        const stateTagName = project.getStateRbTag();
        const tasksDone = filteredTasksList
            .filter(it => !project.isProjectStateOngoing(it[stateTagName]));
        //Sampo: bgColor is not in use for now
        // const getOngoingBgColor = () => {
        //     const task = filteredTasksList
        //         .find(it => project.isProjectStateOngoing(it[stateTagName]));
        //     return this.getBgColor(task);
        // };
        const total = filteredTasksList.length;
        const ongoing = filteredTasksList.length - tasksDone.length;
        //Sampo: bgColor is not in use for now
        //How to select color? Now just pick-up first color of the category
        // const bgColor = total === 0
        //     ? '0xFFFFF'
        //     : ongoing === 0
        //         ? this.getBgColor(tasksDone[0])
        //         : getOngoingBgColor();
        let text = null;
        text = (ongoing === 0 && total === 0 ? null : <><span>{(ongoing || '-')}</span><span>/{total}</span></>)
        if(!text){
            return null;
        }
        const idDiscr = isBefore ? 'b': 'a';
        return <div
                key={`lo-cel-${idDiscr}-${row.index}`}
                title="Kesken/Kaikki"
                className={"schedule-matrix-cell"}
            >
            <span>{text}</span>
        </div>
    }

    toggleBottomPanel() {
        this.setState({
            showBottomPanel: !this.state.showBottomPanel
        }, this.refreshUi)
    }

    makeKanbanColumns() {
        let kanbanColumns = [];
        if ( ! this.hideRow) {
            kanbanColumns.push(
                {
                    Header: <div className="btn-set_center"> </div>,
                    id: 'col-0',
                    Cell: props => {
                        const { row } = props;
                        return (
                            <div className={'actor-header-schedule-matrix'} title={row.original.ui_actor}>
                                {row.original.ui_actor}
                            </div>
                        )
                    }
                }
            )
        }

        this.columns = this.returnTagColumns(kanbanColumns);
    }

    returnTagColumns(kanbanColumnArray) {
        this.kanbanMatrixColumns.forEach((tagColumn, i) => {
            kanbanColumnArray.push({
                Header: <p>{tagColumn.columnTitle}</p>,
                id: 'col-'+ i+1,
                Cell: props => {
                    return this.renderKanbanMatrixCell(tagColumn, props.row, i);
                }
            });
        });
        return kanbanColumnArray;
    }

    renderKanbanMatrixCell(column, row, colIndex) {
        let obj = {};
        let attrs = {}
        // row
        if ( ! this.hideRow) {
            if (this.chosenTagIndex === SPECIAL_TAG_REPORT_IND) {
                obj.reportId = row.original.reportId
            } else {
                this.setSelectedObsMultiValue(obj, row.index);
                attrs[this.chosenTag] = obj[this.chosenTag]
            }
        }
        // col
        if (this.chosenTagIndexForColumns === SPECIAL_TAG_REPORT_IND) {
            obj.reportId = column.original.reportId
        } else {
            obj[this.chosenTagForColumns] = column.tagOptionIds.length === 1 ? column.tagOptionIds[0].toString() : undefined
            attrs[this.chosenTagForColumns] = obj[this.chosenTagForColumns]?.toString()
        }
        return <div
            className={"schedule-matrix-cell"}
            key={obj}
            onDragOver={(e) => this.onDragOver(e)}
            onDrop={(e) => this.onDrop(e, obj, 'renderKanbanMatrixCell')}>
            {this.renderActorTasks(row.original.tasks, column, colIndex)}
            {this.renderAddNewObs(obj.reportId || undefined, attrs)}
        </div>
    }

    makeScheduleMatrixColumns() {
        const hasNoDueDateObs = this.checkOrRenderObsWithoutDueDate().length > 0
        let scheduleMatrixColumns = []
        scheduleMatrixColumns.push({
            Header: <div className="btn-set_center">
                <BasicButton
                    btnClass={"2nd"}
                    icon={"calendar-move"}
                    action={() => {
                        this.setState({
                            showPrevNextHistory: !this.state.showPrevNextHistory
                        }, this.refreshUi)
                    }}
                    title={"Näytä edelliset/seuraavat"}
                    size={"md"}
                    selected={this.state.showPrevNextHistory}
                    hilite={this.state.showPrevNextHistory}
                />
                <BasicButton
                    btnClass={"2nd"}
                    icon={"calendar-none"}
                    action={()=>this.toggleBottomPanel()}
                    title={"Näytä määräajattomat"}
                    size={"md"}
                    selected={this.state.showBottomPanel && hasNoDueDateObs}
                    hilite={this.state.showBottomPanel && hasNoDueDateObs}
                    disabled={!hasNoDueDateObs}
                />
            </div>,
            id: 'col-0',
            Cell: props => {
                const { row } = props;
                return (
                    <div className={'actor-header-schedule-matrix'} title={row.original.ui_actor}>
                        {row.original.ui_actor}
                    </div>
                )
            }
        })
        if(this.state.showPrevNextHistory){
            scheduleMatrixColumns.push(
                {
                    Header: (<div
                            title="Edelliset kirjaukset"
                            className={"icon-set"}
                        >
                            <i className="ui-icon ui-icon-sm ui-icon-arrow-left"/>
                            <i className="ui-icon ui-icon-md ui-icon-calendar"/>
                    </div>),
                    id: 'col-time-left',
                    Cell: props => {
                        const { row } = props;
                        return (
                            <div className={'actor-header-schedule-matrix'}>
                                {this.renderTimeLookoutCell(row, true)}
                            </div>
                        )
                    }
                }
            );
        }
        this.columns = this.returnTasksColumns(scheduleMatrixColumns);
        if(this.state.showPrevNextHistory) {
            this.columns.push(
                {
                    Header: (<div
                            title="Seuraavat kirjaukset"
                            className={"icon-set"}
                        >
                            <i className="ui-icon ui-icon-md ui-icon-calendar"/>
                            <i className="ui-icon ui-icon-sm ui-icon-arrow-right"/>
                    </div>),
                    id: 'col-time-right',
                    Cell: props => {
                        const { row } = props;
                        return (
                            <div className={'actor-header-schedule-matrix'}>
                                {this.renderTimeLookoutCell(row, false)}
                            </div>
                        )
                    }
                }
            );
        }
    }

    renderMatrixCell(timeColumn, row, colIndex) {
        let obj = {};
        let attrs = {}
        if ( ! this.useCreationDate) {
            obj[ATTR_EXPIRATION] = timeColumn.expirationMs
            attrs[ATTR_EXPIRATION] = timeColumn.expirationMs
        }
        if (this.chosenTagIndex === SPECIAL_TAG_REPORT_IND) {
            obj.reportId = row.original.reportId
        } else {
            this.setSelectedObsMultiValue(obj, row.index);
            attrs[this.chosenTag] = obj[this.chosenTag]
        }
        return <div
            className={"schedule-matrix-cell"}
            key={obj}
            onDragOver={(e) => this.onDragOver(e)}
            onDrop={(e) => this.onDrop(e, obj)}>
            {this.renderActorTasks(row.original.tasks, timeColumn, colIndex)}
            {this.renderAddNewObs(obj.reportId || undefined, attrs)}
        </div>
    }

    returnTasksColumns(scheduleMatrixColumArray) {
        this.scheduleMatrixTimeColumns.forEach((timeColumn, i) => {
            scheduleMatrixColumArray.push({
                Header: () => {
                    return (this.renderColumnHeader(timeColumn))
                },
                id: 'col-'+ i+1,
                Cell: props => {
                    return this.renderMatrixCell(timeColumn, props.row, i);
                }
            });
        });
        return scheduleMatrixColumArray;
    }

    renderAddNewObs(report_id = undefined, attrs = {}) {
        if (this.scheduleMatrixViewMode !== scheduleMatrixViewModeType.NORMAL_ITEMS) {
            // No add OBS when showing search result or overview mode xxxx
            return null
        }
        //Todo Jere laita kalenterista oikea tag valituksi kun avataan ProsEditObs
        //En tieda mita nuo alla tekevat
        // if (this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN && this.hideRow) {
        //     return
        // }
        // if (this.chosenTagIndex <= SPECIAL_TAG_REPORT_IND) {
        //     this.setState({ selectedReportId: this.uiActorList[rowIndex].reportId})
        // }
        return <AddObsButton
            btnClass={"3rd"}
            size={"xs"}
            attrs={attrs}
            report={report_id}
        />
    }

    setSelectedObsMultiValue(obs, index) {
        let rowInd = parseInt(index)
        let tagValue
        if (this.actors.length > rowInd+1) {
            tagValue = this.actors[rowInd].actor.toString()
        } else {
            tagValue = STR_NO_VALUE
        }
        obs[this.chosenTag] = tagValue
    }

    // adding new OBS for same day have a time gap to keep them sorted
    // in time matrix in order been  created
    getNewExpiretime(refTimeMs) {
        this.timeOffsetSameDayMs += TIME_OFFSET_MS;
        return (parseInt(refTimeMs) + this.timeOffsetSameDayMs)
    }

    closeSidepanel(){
        this.setState((prevState)=>{
            return {
                showSidepanel: false,
                selectedObsId: (this.state.selectedObsToDrag.length > 0 ? prevState.selectedObsId : undefined)
            }
        })
    }

    openSidepanel(obs) {
        getCopyMoveManager().cancelOperations()
        this.emptyDragList()
        if ((this.state.openedObs === obs && this.state.showSidepanel === true) || !obs) {
            this.closeSidepanel()
            return
        }
        this.setState({
            openedObs: obs,
            showSidepanel: true,
            selectedObsId: obs[ATTR_OBJ_ID] || undefined,
            chosenObsList: this.filterChosenObs(obs[ATTR_OBJ_ID]),
        })
    }

    filterChosenObs(chosenObsId) {
        let project = prosConnect.getActiveProject();
        if (project) {
            if (chosenObsId.length) {
                let matchIdWithObs = project.objs.find((itm) => itm[ATTR_OBJ_ID] === chosenObsId);
                if (matchIdWithObs) {   // id not "id" but OBS obj
                    matchIdWithObs.ui_isOpen = true;
                    return [matchIdWithObs];
                }
            }
        }
    }

    onDragStart(ev, obj) {
        this.draggingObs = obj;
        ev.dataTransfer.setData('text', '');
        this.setState({
            isCopyMode: ev.altKey,
        });
    };

    onDragOver(ev) {
        ev.preventDefault();
    };

    obsWouldChangeCount(obsList, tag, tagValue) {
        return obsList.filter(id => {
            let obj = prosConnect.getObjById(id)
            if (!obj) return false
            return tag === SPECIAL_TAG_REPORT ?
                obj[ATTR_OBJ_ID].indexOf(tagValue) !== 0
                :
                obj[tag] !== tagValue.toString()
        }).length
    }

    async onDrop(ev, obj, where) {
        ev.stopPropagation()
        if (this.state.isCopyMode) {
            if (this.state.selectedObsToDrag.length > 0) {
                prosNotificationShow(this, "Kopiointi vain yksi kerrallaan", 'warning', false)
                return
            }
            getCopyMoveManager().markCopySource(this.draggingObs)
            let newObs = await getCopyMoveManager().onDropped(this.draggingObs, true)
            if (newObs) {
                getCopyMoveManager().cancelOperations()
                let attrChange = {
                    [ATTR_OBJ_ID]: newObs[ATTR_OBJ_ID],
                    [ATTR_OBJ_TYPE]: newObs[ATTR_OBJ_TYPE],
                }
                if (this.chosenTag !== SPECIAL_TAG_REPORT) {
                    if (prosConnect.getObjAttr(obj, this.chosenTag, STR_NO_VALUE) !== STR_NO_VALUE) {
                        newObs[this.chosenTag] = obj[this.chosenTag]
                        attrChange[this.chosenTag] = obj[this.chosenTag]
                    }
                }
                if (this.props.viewMode && this.props.viewMode !== VIEW_MODE_KANBAN) {
                    if ( ! this.useCreationDate) {
                        this.changeExpirationTime(obj, newObs);
                    }
                } else {
                    if (this.chosenTagForColumns !== SPECIAL_TAG_REPORT) {
                        if (prosConnect.getObjAttr(obj, this.chosenTagForColumns, STR_NO_VALUE) !== STR_NO_VALUE) {
                            newObs[this.chosenTagForColumns] = obj[this.chosenTagForColumns]
                            attrChange[this.chosenTagForColumns] = obj[this.chosenTagForColumns]
                        }
                    }
                }
                await prosConnect.getActiveProject().awaitUpdateMultipleItemsAttributes([attrChange])
            }
        } else {
            if ( ! obj.hasOwnProperty(ATTR_EXPIRATION) && this.props.viewMode !== VIEW_MODE_KANBAN && ! this.useCreationDate) {
                return
            }
            let expireTime = this.getNewExpiretime(obj[ATTR_EXPIRATION])
            // row
            let tag
            let tagValue
            let targetTagValue
            if (this.chosenTag === SPECIAL_TAG_REPORT) {
                targetTagValue = obj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS
                    ? prosConnect.getObjListIdFromItemId(obj[ATTR_OBJ_ID])
                    : obj.reportId
            } else {
                targetTagValue = prosConnect.getValidAttr(obj, this.chosenTag, STR_NO_VALUE)
            }
            if (targetTagValue !== STR_NO_VALUE) {
                tag = this.chosenTag
                tagValue = targetTagValue
            }
            // column
            let columnTag
            let columnTagValue
            let columnTargetTagValue
            if (this.chosenTagForColumns === SPECIAL_TAG_REPORT) {
                columnTargetTagValue = obj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS
                    ? prosConnect.getObjListIdFromItemId(obj[ATTR_OBJ_ID])
                    : obj.reportId
            } else {
                columnTargetTagValue = prosConnect.getValidAttr(obj, this.chosenTagForColumns, STR_NO_VALUE)
            }
            if (columnTargetTagValue !== STR_NO_VALUE) {
                columnTag = this.chosenTagForColumns
                columnTagValue = columnTargetTagValue
            }
            let wouldChangeRow = this.obsWouldChangeCount(this.state.selectedObsToDrag, tag, tagValue)
            if (wouldChangeRow ||
                (this.chosenTag === SPECIAL_TAG_REPORT && this.draggingObs[ATTR_OBJ_ID].indexOf(tagValue) !== 0)) {
                // When dragging multiple prompt to change only time or time+row
                // Also if would change report ask if would like to do that
                this.setState({
                    promptDraggingToChangeRow: {
                        draggingObs: this.draggingObs,
                        expireTime: expireTime,
                        tag: tag,
                        tagValue: tagValue,
                        columnTag: columnTag,
                        columnTagValue: columnTagValue,
                    }
                })
                //this.openPopupPromptToChangeRow(this.draggingObs, expireTime, tag, tagValue)
                this.openPopupPromptToChangeRow(this.draggingObs, expireTime, tag, tagValue, columnTag, columnTagValue)
            } else {
                // Dragging one OBS change expiration and TAG when row is by multivalue
                await this.changeSelectedObsExpiration(this.draggingObs, expireTime, tag, tagValue, columnTag, columnTagValue)
            }
        }
        this.setState({
            isCopyMode: false,
        });
    };

    async changeExpirationTime(refObj, forObs) {
        if (!refObj || !forObs || !refObj.hasOwnProperty(ATTR_EXPIRATION)) {
            return
        }
        if (refObj[ATTR_OBJ_ID] !== this.draggingObs[ATTR_OBJ_ID]) {
            if (!prosConnect.hasPermissionTo("editExpiration", forObs, undefined, false)) {
                prosNotificationShow(this, "Ei käyttöoikeutta tai projekti on arkistoitu", 'warning', false);
            } else {
                let expireTime = this.getNewExpiretime(refObj[ATTR_EXPIRATION])
                let attrChange = {
                    [ATTR_OBJ_ID]: forObs[ATTR_OBJ_ID],
                    [ATTR_OBJ_TYPE]: forObs[ATTR_OBJ_TYPE],
                    [ATTR_EXPIRATION]: expireTime.toString()
                }
                await prosConnect.getActiveProject().awaitUpdateMultipleItemsAttributes([attrChange])
                this.draggingObs = undefined
                this.emptyDragList()
            }
        }
    }

    renderTaskContentOverviewGroups(itm, i, index, text, disabled) {
        return (
            <div key={itm[ATTR_OBJ_ID]}
                 draggable={false}
                 className={"calendar-card overview-item" + (this.state.selectedObsGroupId === itm[ATTR_OBJ_ID] ? " overview-item_selected" : '')}
                 style={(this.getBgColor(itm) ? {backgroundColor: this.getBgColor(itm)} : {})}
            >
                <section
                    key={itm}
                    disabled={disabled}
                    draggable={false}
                     onClick={(e)=> {
                         let newGroupOpenedState = this.state.selectedObsGroupId === itm[ATTR_OBJ_ID] ? undefined : itm[ATTR_OBJ_ID];
                         this.setState({selectedObsGroupId: newGroupOpenedState});
                         e.stopPropagation();
                     }}
                >
                    <span>{text}</span>
                </section>
            </div>
        )
    }

    renderDateButtonAndStateIcons(obs) {
        let useButtonTitle = prosConnect.hasPermissionTo("editExpiration", obs) ?
                "Tallenna" : undefined
        if (this.scheduleMatrixViewMode !== scheduleMatrixViewModeType.NORMAL_ITEMS) {
            useButtonTitle = false
        }
        return <ProsDate
            iconOnly={true}
            timeMs={prosConnect.getExpiration(obs)}
            timeTitle={"Määräaika"}
            useButtonTitle={useButtonTitle}
            disabled={this.state.showSidepanel}
            stateIcons={stateIcons(obs, 'sm')}
            onTimeChanged={timeMs => this.changeSelectedObsExpiration(obs, timeMs)}
        />
    }

    renderTaskContentItemsOfGroup(project, itm, i, index, disabled) {
        return <div key={"gitem" + itm[ATTR_OBJ_ID]}
                 disabled={disabled}
                 onDragStart={(e) => this.onDragStart(e, itm)}
                 draggable={!disabled}
                 onDragOver={(e) => this.onDragOver(e)}
                 onDrop={(e) => { this.onDrop(e, itm) }}
                 className={"calendar-card overview-item"}
                 onClick={ e => this.addObsToDragListWithShift(e, itm) }
                 onDoubleClick={()=>this.emptyDragList()}
            >
            <section
                 key={`gitem-s-${i + index}`}
                 draggable={false}
                 onClick={(e)=> {
                    this.openSidepanel(itm);
                    e.stopPropagation();
                }}
            >
                <p className={"inline-flex"}>
                    {this.renderDateButtonAndStateIcons(itm)}
                    <span>{itm.ui_text}</span></p>
            </section>
        </div>
    }

    getSelectedStyle(obs) {
        return this.state.selectedObsToDrag.includes(obs.obj_id) || this.state.selectedObsId === obs.obj_id ?
            " calendar-card-selected" : ""
    }

    renderTaskContentOverviewItems(project, itm, i, index) {
        let mayChange = prosConnect.hasPermissionTo("editObj", itm)
        return (
            <div key={itm[ATTR_OBJ_ID]}
                 onDragStart={(e) => this.onDragStart(e, itm)}
                 draggable={mayChange || null}
                 onDragOver={(e) => this.onDragOver(e)}
                 onDrop={(e) => { this.onDrop(e, itm) }}
                 className={"overview-item calendar-card" + this.getSelectedStyle(itm)}
                 style={{backgroundColor: this.getBgColor(itm)}}
                 onClick={ e => this.addObsToDragListWithShift(e, itm) }
                 onDoubleClick={()=>this.emptyDragList()}
            >
                <section
                    key={itm}
                    draggable={false}
                    onClick={(e)=> {
                        if (!e.shiftKey) {
                            this.openSidepanel(itm)
                            e.stopPropagation()
                        }
                    }}
                >
                    <p>
                        {this.renderDateButtonAndStateIcons(itm)}
                        <span>{itm.ui_text}</span>
                    </p>
                </section>
            </div>
        )
    }

    renderTaskContent(obs, hasDueDate = true) {
        let mayChange = prosConnect.hasPermissionTo("editObj", obs)
        return <div
                key={obs[ATTR_OBJ_ID]}
                onDragStart={(e) => this.onDragStart(e, obs)}
                draggable={mayChange || null}
                onDragOver={(e) => {
                    if(!hasDueDate && ! this.useCreationDate) return
                    this.onDragOver(e)
                }}
                onDrop={(e) => {
                    if(!hasDueDate && ! this.useCreationDate) return
                    this.onDrop(e, obs, 'renderTaskContent')
                }}
                onClick={(e)=> {
                    e.stopPropagation()
                    this.addObsToDragListWithShift(e, obs)
                }}
                onDoubleClick={()=>this.emptyDragList()}
                className={"calendar-card " + this.getSelectedStyle(obs)}
                style={{backgroundColor: this.getBgColor(obs)}}
            >
            <header
                draggable={false}
            >
                {this.renderDateButtonAndStateIcons(obs)}
            </header>
            <section
                draggable={false}
                onClick={e => {
                    if (!e.shiftKey) {
                        this.openSidepanel(obs)
                        e.stopPropagation()
                    }
                }}
                className={"bgcolor-hilite"}
            >
                <p>{obs.ui_text}</p>
                {renderObsAttachments(obs, false)}
            </section>
        </div>
    }

    returnObsListWithoutUtc(obsList) {
        if (!obsList.length) {
            return
        }
        return obsList.map((obs, i) => {
            return this.renderTaskContent(obs, false)
        })
    }

    getBgColor(obs) {
        let project = prosConnect.getActiveProject();
        let chosenTag = project.tagIndexToId(this.chosenBgIndex);
        let hexNumber = project.getBgHexNumber(obs, chosenTag, true);
        return hexNumber ? "#" + hexNumber : null
    }

    renderActorTasks(personTasksArray, column, index) {
        let project = prosConnect.getActiveProject();
        let filteredPersonTasksList = personTasksArray.filter((itm) => {
            if (this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN) {
                if (column.otherColumn && ! (column.tagId in itm)) {
                    return true
                }
                if ( ! column.tagOptionIds) {
                    return false
                }
                return column.tagOptionIds.findIndex(optionId => (optionId.toString()) === (itm[column.tagId])) > -1;
            }
            let expirationMs
            if (this.useCreationDate) {
                expirationMs = prosConnect.getCreation(itm)
            } else {
                expirationMs = prosConnect.getExpiration(itm)
            }
            if (!expirationMs) {
                return false;
            }
            let itemExpireDate = new Date(parseInt(expirationMs));
            let itemTimeTitle = this.getColumnTimeTitle(itemExpireDate, itemExpireDate, this.scheduleMatrixInterval);
            if (itemTimeTitle.columnKey !== column.columnKey) {
                // no match for time column
                return false;
            }
            return true;
        });

        if (this.scheduleMatrixViewMode === scheduleMatrixViewModeType.OVERVIEW_GROUPS) {
            return this.renderActorTasksByGroups(project, filteredPersonTasksList, index);
        }
        else if (this.scheduleMatrixViewMode === scheduleMatrixViewModeType.OVERVIEW_ITEMS) {
            return filteredPersonTasksList.map((itm, i) => {
                return this.renderTaskContentOverviewItems(project, itm, i, index);
            });
        }
        return filteredPersonTasksList.map((itm, i) => {
            return this.renderTaskContent(itm)
        })
    }

    renderActorTasksByGroups(project, filteredPersonTasksList, index, disableClicks) {
        const MINIMUM_WIDTH_RATIO_TRIAL = 25;
        let groupByTag = this.chosenBg;
        const tasksByState = prosConnect.groupItemsByState(filteredPersonTasksList, groupByTag);

        const filteredStateList = Object.keys(tasksByState).reverse()
            .filter((state) => tasksByState[state].length > 0);

        let totalCount = filteredPersonTasksList.length;

        const calculateGroupRatios = () => {
            let newRatios = filteredStateList
                .map((state) => {
                    let rat = tasksByState[state].length / totalCount * 100;
                    if(rat < MINIMUM_WIDTH_RATIO_TRIAL){
                        return MINIMUM_WIDTH_RATIO_TRIAL;
                    }
                    return Math.round(rat);
                });
            let totalRatiosSum = Math.round(newRatios.reduce((total, it) => total + it, 0));
            if (totalRatiosSum > 100){
                // Total exceeds 100% - it means we have increased small originals with minimum size. 
                // Therefore we need to recalculate ratios with new total
                newRatios = newRatios
                    .map((value) => {
                        return Math.round(value / totalRatiosSum * 100);
                    });
                totalRatiosSum = Math.round(newRatios.reduce((total, it) => total + it, 0));
            }
            if (totalRatiosSum !== 100){
                // Final fine-tune adjustment due to integer rounding
                newRatios[newRatios.length-1] = newRatios[newRatios.length-1] - (totalRatiosSum - 100);
            }
            return newRatios;
        }
        
        let ratios = calculateGroupRatios();

        const groups = filteredStateList
            .map((state, index) => {
                let ratio = ratios[index];
                const firstObs = tasksByState[state][0];
                return <div key={`group-${state}`} style={{width: `${ratio}%`}}>
                    {this.renderTaskContentOverviewGroups(firstObs, 0, index, tasksByState[state].length, disableClicks)}
                </div>;       
            });

        const selectedGroupState = filteredStateList
            .find(state => {
                const firstObs = tasksByState[state][0];
                return this.state.selectedObsGroupId === firstObs[ATTR_OBJ_ID];       
            });

        if(selectedGroupState){
            // This is applied when opening the group by selecting/clicking the group
            return <div key={`g-t${index}`} className={"task-groups-and-items-container"}>
                <div className={"task-groups-container"}>
                    {groups}
                </div>
                <div key={`t${index}`} className={"task-group-opened-items-container"}>
                    {tasksByState[selectedGroupState].map((itm, i) => {
                        return this.renderTaskContentItemsOfGroup(project, itm, i, index, "", disableClicks);
                    })}
                </div>
            </div>;
        }
        // This is when no group opened but only groups shown
        return groups;
    }

    addObsToDragListWithShift(e, obs) {
        if (!e) {
            return false
        }
        if (e.shiftKey) {
            // Add selected OBS to group selection list if not already
            if (this.state.selectedObsToDrag.includes(obs.obj_id)) {
                // remove
                this.setState({
                    selectedObsToDrag: this.state.selectedObsToDrag
                        .filter(obsId => obsId !== obs.obj_id)
                })
            } else {
                // add
                this.setState({
                    selectedObsToDrag: [...this.state.selectedObsToDrag, obs.obj_id]
                }, ()=>{
                    this.closeSidepanel()
                })
            }
            return true
        }
        // otherwise return false to indication no actions been taken
        return false
    }

    emptyDragList() {
        this.setState({
            selectedObsToDrag: []
        })
    }

    /**
     * Change group of OBS from drag or triggered by modified by calendar
     * @param selectedObs               OBS to be modified when only one - reference OBS when multiple
     * @param expireMs                  New expiration time in ms
     * @param tag                       Dropped - TAG changed, optional
     * @param tagValue                  Dropped - TAG value, optional
     * @param columnTag                 DroppedColumn - TAG changed, optional
     * @param columnTagValue            DroppedColumn - TAG value, optional
     * @returns {Promise<void>}
     */
    async changeSelectedObsExpiration(selectedObs, expireMs = false, tag = '', tagValue = '', columnTag = '', columnTagValue = '') {

        function makeObsObjsToReport(obs, reportId) {
            let changes = []
            // to change report create new OBS for target report and delete the old one
            let newObs = prosConnect.makeObjCopyForAws(obs, true)
            newObs[ATTR_OBJ_ID] = prosConnect.makeNewObjId(reportId)
            newObs[ATTR_SORT_ORDER_I] = getMonotonicTimeMs()
            changes.push(newObs)
            // Copy comments and pictures and set their parent OBS id
            for (let obj of obs[OBS_OBJ_LIST]) {
                let newObj = prosConnect.makeObjCopyForAws(obj, true)
                newObj[ATTR_OBJ_ID] = prosConnect.makeNewObjId(reportId)
                newObj[ATTR_SORT_ORDER_I] = getMonotonicTimeMs()
                newObj[ATTR_PARENT_OBS] = newObs[ATTR_OBJ_ID]
                changes.push(newObj)
                // Remove old item from its old report
                let delObj = prosConnect.makeObjCopyForAws(obj)
                delObj[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL
                changes.push(delObj)
            }
            return changes
        }

        if (this.props.viewMode && this.props.viewMode !== VIEW_MODE_KANBAN) {
            columnTag = ''
            columnTagValue = ''
        }

        let updateObsList = []
        let selectedObsTimeMs = 0
        for (const obsId of this.state.selectedObsToDrag) {
            // selected multiple OBS using shift-key
            let obs = prosConnect.getObjById(obsId)
            if (obs) {
                if (selectedObs === obs) {
                    selectedObsTimeMs = prosConnect.getExpiration(obs)
                }
                updateObsList.push(obs)
            }
        }
        if (updateObsList.length < 1) {
            // Just one selected
            selectedObsTimeMs = prosConnect.getExpiration(selectedObs)
            updateObsList.push(selectedObs)
        }
        if (expireMs && ! this.useCreationDate) {
            this.updateSelectedObsExpiration(updateObsList, expireMs, selectedObs, selectedObsTimeMs)
        }
        let reportChanges = []
        updateObsList.forEach(obs => {
            if (tag && tag !== SPECIAL_TAG_REPORT) {
                // change TAG
                obs[tag] = tagValue !== undefined ? tagValue.toString() : STR_NO_VALUE
            }
            if (columnTag && columnTag !== SPECIAL_TAG_REPORT) {
                // change column TAG
                obs[columnTag] = columnTagValue !== undefined ? columnTagValue.toString() : STR_NO_VALUE
            }
            if (tag === SPECIAL_TAG_REPORT) {
                reportChanges = reportChanges.concat(makeObsObjsToReport(obs, tagValue))
                obs[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL
            }
            if (columnTag === SPECIAL_TAG_REPORT) {
                reportChanges = reportChanges.concat(makeObsObjsToReport(obs, columnTagValue))
                obs[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL
            }
        })
        if (reportChanges.length > 0) {
            // Moved from report to another
            await prosConnect.getActiveProject()
                .awaitUpdateMultipleItems(updateObsList.concat(reportChanges), true)
        } else {
            // Dragged to change expiration and optionally tag, too
            let attrChanges = updateObsList.map(obs => {
                let attrChange = {
                    [ATTR_OBJ_ID]: obs[ATTR_OBJ_ID],
                    [ATTR_OBJ_TYPE]: obs[ATTR_OBJ_TYPE],
                    [ATTR_EXPIRATION]: obs[ATTR_EXPIRATION]
                }
                if (tag) {
                    attrChange[tag] = tagValue !== undefined ? tagValue.toString() : STR_NO_VALUE
                }
                if (columnTag) {
                    attrChange[columnTag] = columnTagValue !== undefined ? columnTagValue.toString() : STR_NO_VALUE
                }
                return attrChange
            })
            await prosConnect.getActiveProject()
                .awaitUpdateMultipleItemsAttributes(attrChanges, true)
        }
        this.emptyDragList()
    }

    updateSelectedObsExpiration(updateObsList, expireMs, selectedObs, selectedObsTimeMs) {
        let offsetMs = expireMs - selectedObsTimeMs
        let spacingTime = 0
        let useOffsetToFirst = selectedObsTimeMs > 0
        updateObsList.forEach(obs => {
            spacingTime += 100
            let newExpireTimeForObs
            if (selectedObs[ATTR_OBJ_ID] === obs[ATTR_OBJ_ID]) {
                // selected - use new time
                newExpireTimeForObs = expireMs
            } else if (useOffsetToFirst) {
                let prevExpire = prosConnect.getExpiration(obs)
                if (prevExpire) {
                    // keep same time distance when dragging multiple
                    newExpireTimeForObs = prevExpire + offsetMs
                } else {
                    newExpireTimeForObs = expireMs + spacingTime
                }
            } else {
                newExpireTimeForObs = expireMs + spacingTime
            }
            obs[ATTR_EXPIRATION] = newExpireTimeForObs.toString()
        })
    }

    renderObsWithoutUtc() {
        let obsList = this.checkOrRenderObsWithoutDueDate(true)
        if(obsList.length < 1 || !this.state.showBottomPanel) return null
        return <div id={"bottomPanel"} className={"slab"}>
            <div className={"element-set valign-center"}>
                <h2 className={"flex-grow margin-0"}>Kirjaukset ilman määräaikaa</h2>
                <BasicButton
                    icon={"times"}
                    action={()=>this.toggleBottomPanel()}
                />
            </div>
            <div className={"grid-container grid-1 grid-2_xxl"}>
                {obsList}
            </div>
        </div>
    }

    // Now returns depending on selected time expiration on creation
    returnObsListWoTime(obsList) {
        return obsList
            .filter(obs => {
                if (this.useCreationDate) {
                    return prosConnect.isObservation(obs) && !prosConnect.getCreation(obs)
                }
                return prosConnect.isObservation(obs) && !prosConnect.getExpiration(obs)
            })
            .sort((a, b) => a[ATTR_SORT_ORDER_I] - (b[ATTR_SORT_ORDER_I]));
    }

    changeCalendarInterval(interval) {
        this.scheduleMatrixInterval = interval;
        this.refreshUi();
    }

    getRbTagList() {
        let project = prosConnect.getActiveProject();
        let rbTagTitles = project.getRbTagTitles();
        let rbTagList = [];
        rbTagTitles.forEach((itm, i) => {
            rbTagList.push({
                title: itm,
                index: i,
                tag: project.tagIndexToId(i),
            });
        })
        return rbTagList
    }

    getColumnOptions() {
        if (this.chosenTagForColumns === SPECIAL_TAG_REPORT) {
            let project = prosConnect.getActiveProject();
            let reports = project.getReports();
            let columnOptions = []
            reports.forEach((itm, i) => {
                columnOptions.push({
                    title: itm,
                    index: i,
                });
            })
            return columnOptions
        }
        return this.getRbTagOptions()
    }

    getRbTagOptions() {
        let project = prosConnect.getActiveProject();
        let mvTagSettings = project.getMvTagSettings(this.chosenTagIndexForColumns)
        if(!mvTagSettings) return []
        let rbTagList = []
        mvTagSettings.options.forEach(option => {
            if ( ! option.inUse) {
                return
            }
            rbTagList.push({
                title: option.label,
                index: option.optionIndex,
            })
        })
        return rbTagList
    }

    renderSelectButton(title, chosen, callBack, param, specialClass, disable = false) {
        return <BasicButton key={"tagbutton_" + Array.isArray(param) ? param[0] : param}
            label={title}
            className={specialClass || null}
            action={() => { callBack(this, ...param) }}
            selected={chosen} disabled={disable}
        />
    }

    renderRowTitleSelectButtons(stagList) {
        if (stagList) {
            return stagList.map((item, i) => {
                return this.renderSelectButton(
                    stagList[i].title,
                    stagList[i].index === this.chosenTagIndex,
                    this.changeTagIndex,
                    [i, false],
                    '',
                    this.hideRow && this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN
                );
            }).concat(
                this.renderSelectButton(
                    "Katso raporteittain",
                    SPECIAL_TAG_REPORT_IND === this.chosenTagIndex,
                    this.changeTagIndex,
                    [SPECIAL_TAG_REPORT_IND, false],
                    " reports",
                    this.hideRow && this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN
                )
            )
        }
    }

    renderColTitleSelectButtons(stagList) {
        if ( ! stagList) {
            return
        }
        return stagList.map((item, i) => {
            return this.renderSelectButton(
                stagList[i].title,
                stagList[i].index === this.chosenTagIndexForColumns,
                this.changeTagIndex,
                [i, true]
            )
        })
    }

    renderColumnTagOptionsSelectButtons(optionList) {
        if (optionList) {
            return optionList.map((item, i) => {
                return this.renderSelectButton(
                    optionList[i].title,
                    this.chosenTagOptions.indexOf(optionList[i].index) > -1,
                    this.chooseTagOption,
                    [optionList[i].index],
                );
            })
        }
    }

    renderColorSelectButtons(stagList) {
        if (stagList) {
            return stagList.map((item, i) => {
                return this.renderSelectButton(
                    stagList[i].title,
                    stagList[i].index === this.chosenBgIndex,
                    this.changeBgIndex,
                    [i]
                )
            })
        }
    }

    closeTagList() {
        prosPopupClose()
    }

    radioButton(label, checked, state) {
        return <RadioButton
            checked={checked}
            text={label}
            onChange={() => {
                this.useCreationDate = state
                this.refreshUi()
            }}
        />
    }

    renderMatrixSelections(){
        let rbTagList = this.getRbTagList()
        return <>
            <section>
                <h3>Lajittelu</h3>
                <div className="selection-group selection-group-radio">
                    {this.radioButton("Käytä määräaikaa", ! this.useCreationDate, false)}
                    {this.radioButton("Käytä luontiaikaa", this.useCreationDate, true)}
                </div>
                <div className={"grid-container grid-2"}>
                    <div>
                        <h3>Riviotsikko</h3>
                        <div className={"tag-list"}>
                            {this.renderRowTitleSelectButtons(rbTagList)}
                        </div>
                    </div>
                    <div>
                        <h3>Kortin taustaväri</h3>
                        <div className={"tag-list"}>
                            {this.renderColorSelectButtons(rbTagList)}
                        </div>
                    </div>
                </div>
            </section>
            {this.renderViewOptionsPopupFooter()}
        </>
    }

    renderTagOptionsSelections() {
        let rbTagList = this.getRbTagList()
        return <>
            <section>
                <div className={"grid-container grid-2 flex-gap-lg"}>
                    <div>
                        <header className={"element-set-sm margin-bottom valign-center"}>
                            <h3 className={"flex-grow margin-0"}>Riviotsikko</h3>
                            <ToggleSwitch
                                label={"Rivinjako"}
                                defaultChecked={!this.hideRow}
                                onChange={()=> {
                                    this.hideRow = !this.hideRow
                                    this.refreshUi()
                                }}
                                className={"text-sm"}
                            />
                        </header>
                        <div className={"tag-list"}>
                            {this.renderRowTitleSelectButtons(rbTagList)}
                        </div>
                    </div>
                    <div>
                        <h3>Kortin taustaväri</h3>
                        <div className={"tag-list"}>
                            {this.renderColorSelectButtons(rbTagList)}
                        </div>
                    </div>
                </div>
                <Spacer size={"lg"}/>
                <div className={"grid-container grid-2 margin-top"}>
                    <div>
                        <h3>Sarakeotsikko</h3>
                        <div className={"tag-list"}>
                            {this.renderColTitleSelectButtons(rbTagList)}
                        </div>
                    </div>
                    <div>
                        <Spacer size={"lg"}/>
                        <div className={"element-indented margin-top"}>
                            <header className={"element-set-sm margin-bottom valign-center"}>
                                <h6 className={"flex-grow margin-0"}>Sarake otsikot</h6>
                                <ToggleSwitch
                                    label={"Näytä muut sarake"}
                                    defaultChecked={this.kanbanColumnOthers}
                                    onChange={()=> {
                                        this.kanbanColumnOthers = !this.kanbanColumnOthers
                                        this.refreshUi()
                                    }}
                                    className={"text-sm"}
                                />
                            </header>
                            <div className={"tag-collection"}>
                                {this.renderColumnTagOptionsSelectButtons(this.getColumnOptions())}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {this.renderViewOptionsPopupFooter()}
        </>
    }

    renderViewOptionsPopupFooter(){
        return <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                <ConfirmButton
                    label={"Valmis"}
                    action={()=> this.closeTagList()}
                />
            </div>
        </footer>
    }

    openPopupTagList() {
        prosPopupOpenDynamic(this,
            'Näkymän valinnat',
            ()=> this.renderMatrixSelections(),
        )
        setHelpContext('timeMatrixTags')
    }

    closeMultiDragPopup() {
        this.setState({promptDraggingToChangeRow: undefined})
        prosPopupClose()
    }

    openPopupPromptToChangeRow(draggingObs, expireTime, tag, tagValue, columnTag, columnTagValue) {
        let changeCount = this.state.selectedObsToDrag.length ? this.state.selectedObsToDrag.length : 1
        let project = prosConnect.getActiveProject()
        let onlyColumnButtonAction, columnAndRowButtonAction, onlyRowButtonAction
        let rowLabel = tag === SPECIAL_TAG_REPORT ? "raportti" : project.getRbTagTitles()[project.tagIdToIndex(tag)]
        let columnLabel = columnTag === SPECIAL_TAG_REPORT ? "raportti" : project.getRbTagTitles()[project.tagIdToIndex(columnTag)]
        let promptTxt = "Muutetaanko valituille " + changeCount + " kirjaukselle "
        if (this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN) {
            promptTxt = promptTxt + columnLabel + " sekä " + rowLabel + " ?"
            onlyRowButtonAction = () => {
                this.changeSelectedObsExpiration(draggingObs, false, tag, tagValue)
                this.closeMultiDragPopup()
            }
            onlyColumnButtonAction = () => {
                this.changeSelectedObsExpiration(draggingObs, false, '', '', columnTag, columnTagValue)
                this.closeMultiDragPopup()
            }
            columnAndRowButtonAction = () => {
                this.changeSelectedObsExpiration(draggingObs, false, tag, tagValue, columnTag, columnTagValue)
                this.closeMultiDragPopup()
            }
        } else if (this.useCreationDate) {
            promptTxt = promptTxt + rowLabel + " ?"
            columnAndRowButtonAction = () => {
                this.changeSelectedObsExpiration(draggingObs, false, tag, tagValue)
                this.closeMultiDragPopup()
            }
        } else {
            columnLabel = 'Määräaika'
            promptTxt = promptTxt + "määräajan lisäksi " + rowLabel + " ?"
            onlyRowButtonAction = () => {
                this.changeSelectedObsExpiration(draggingObs, false, tag, tagValue)
                this.closeMultiDragPopup()
            }
            onlyColumnButtonAction = () => {
                this.changeSelectedObsExpiration(draggingObs, expireTime)
                this.closeMultiDragPopup()
            }
            columnAndRowButtonAction = () => {
                this.changeSelectedObsExpiration(draggingObs, expireTime, tag, tagValue)
                this.closeMultiDragPopup()
            }
        }

        prosPopupOpen(this,
            'Vahvista muutos',
            <><section>
                <p>{promptTxt}</p>
            </section>
                <footer className={"popup-footer"}>
                    <div className={"btn-set"}>
                        { this.useCreationDate ? null : <>
                            <BasicButton
                                btnClass={"2nd"}
                                label={"Vain " + rowLabel.toLowerCase()}
                                action={onlyRowButtonAction}
                            />
                            <BasicButton
                                btnClass={"2nd"}
                                label={"Vain " + columnLabel.toLowerCase()}
                                action={onlyColumnButtonAction}
                            />
                        </> }
                        <CancelButton
                            action={() => { this.closeMultiDragPopup() }}
                        />
                        <ConfirmButton
                            label={this.useCreationDate ? 'Kyllä' : columnLabel + " ja " + rowLabel}
                            action={columnAndRowButtonAction}
                        />
                    </div>
                </footer>
            </>,
            () => this.closeMultiDragPopup())
    }

    // Change number of columns
    editColumnAmount(edit) {
        // edit is
        //      COL_CHANGE_RESET to set default
        //      COL_CHANGE_INCREMENT add one column
        //      COL_CHANGE_DECCREMENT reduce number of columns
        let columnDef = this.columnDefs[this.scheduleMatrixInterval]
        let curr = this.columnDefs[this.scheduleMatrixInterval].curr
        if (edit === COL_CHANGE_RESET) {
            curr = columnDef.DEFAULT
        } else {
            let change = edit === COL_CHANGE_INCREMENT ? 1 : -1;
            curr += change;
            if (curr > columnDef.MAX) {
                curr = columnDef.MAX
            }
            if (curr < columnDef.MIN) {
                curr = columnDef.MIN
            }
        }
        this.columnDefs[this.scheduleMatrixInterval].curr = curr
        this.refreshUi()
    }

    renderMatrix() {
        return <ScheduleMatrixTable
            data={this.uiActorList}
            columns={this.columns}
            showPagination={false}
            minRows={0}
            sortable={false}
            renderMatrixSettings={this.renderTableControls()}
            viewMode={this.props.viewMode}
        />
    }

    renderTableControls() {
        return <>
            <div className="table-options element-set-sm">
                {this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN
                ? this.renderKanbanControls()
                : this.renderCalendarControls()}
            </div>
            {this.props.renderToolbar()}
        </>
    }

    handleMatrixViewModeChange(newMode){
        this.scheduleMatrixViewMode = newMode
        this.refreshUi()
        this.updateMaySendPdf()
    }

    returnIntervalOptions(){
        return SCHED_INTERVALS.map((schedInterval, i) => {
            let columnDef = this.columnDefs[schedInterval];
            return {value: schedInterval, text: columnDef.title}
        })
    }

    renderMatrixViewModeToggle() {
        const views = [
            {
                text: 'Oletusasetus',
                icon: 'view-table',
                key: 'normalItems'
            },
            {
                text: 'Tiivistelmä',
                icon: 'view-timeline',
                key: 'overviewItems'
            },
            {
                text: 'Aikajanat',
                icon: 'view-gantt',
                key: 'overviewGroups'
            }
        ]
        const viewObjs = views.map(view=>{
            return {
                text: view.text,
                icon: view.icon,
                action: ()=> this.handleMatrixViewModeChange(view.key),
                selected: this.scheduleMatrixViewMode === view.key
            }
        })
        const currentIcon = views.filter(item => item.key === this.scheduleMatrixViewMode)[0].icon
        return <DropdownMenu
            values={viewObjs}
            currentValue={this.scheduleMatrixViewMode}
            text={false}
            btnClass={"3rd"}
            icon={currentIcon}
            active={this.scheduleMatrixViewMode !== views[0].key}
        />
    }

    renderCalendarControls() {
        return <>
            <BasicButton
                icon={"sliders"}
                label={"Valinnat"}
                action={() => {
                    this.openPopupTagList()
                }}
                btnType={"prompt"}
                title={"Näkymän valinnat"}
            />
            {this.renderMatrixViewModeToggle()}
            <div className="btn-set-2nd">
                <span title={"Nyt"}
                      className={"btn btn-3rd btn-icon btn-icon-calendar-today"}
                      onClick={() => this.goToPresentTime() }>
                    <span/>
                </span>
                <BasicButton
                    title={"Edellinen (Nopea)"}
                    icon={"chevron-double-left"}
                    action={() => { this.moveTimeForwards(false, true)}}
                    iconSize={"md"}
                />
                <BasicButton
                    title={"Edellinen"}
                    icon={"chevron-left"}
                    action={() => { this.moveTimeForwards(false)}}
                    iconSize={"md"}
                />
                <DropdownMenu
                    values={this.returnIntervalOptions()}
                    currentValue={this.scheduleMatrixInterval}
                    onSelect={(retVal)=>{
                        this.changeCalendarInterval(retVal);
                    }}
                    btnClass={"3rd"}
                />
                <BasicButton
                    title={"Seuraava"}
                    icon={"chevron-right"}
                    action={() => this.moveTimeForwards(true)}
                    iconSize={"md"}
                />
                <BasicButton
                    title={"Seuraava (Nopea)"}
                    icon={"chevron-double-right"}
                    action={() => this.moveTimeForwards(true, true) }
                    iconSize={"md"}
                />
            </div>
            <div className={"btn-set-2nd"}>
                <BasicButton
                    icon={"minus"}
                    action={()=>{
                        this.editColumnAmount(COL_CHANGE_DECREMENT)
                    }}
                    size={"md"}
                    title={"Poista sarake"}
                />
                <BasicButton
                    icon={"table"}
                    action={()=>{
                        this.editColumnAmount(COL_CHANGE_RESET)
                    }}
                    tooltip={["Palauta oletus", "tooltip-bottom"]}
                />
                <BasicButton
                    icon={"plus"}
                    action={()=>{
                        this.editColumnAmount(COL_CHANGE_INCREMENT)
                    }}
                    size={"md"}
                    title={"Lisää sarake"}
                />
            </div>
        </>
    }

    renderKanbanControls() {
        return <>
            <BasicButton
                label={"Valinnat"}
                icon={"kanban"}
                action={()=>{
                    this.openPopupColumnTagOptionsList()
                }}
                btnType={"prompt"}
                title={"Näkymän valinnat"}
            />
            {this.renderMatrixViewModeToggle()}
        </>
    }

    openPopupColumnTagOptionsList() {
        prosPopupOpenDynamic(this,
            'Näkymän valinnat',
            ()=> this.renderTagOptionsSelections(),
        )
        setHelpContext('timeMatrixTags')
    }

    getBgColorByTagValue(tagValue) {
        let project = prosConnect.getActiveProject()
        let chosenTag = project.tagIndexToId(this.chosenBgIndex)
        let hexNumber = project.getBgHexNumberByTagValue(chosenTag, tagValue, true)
        return hexNumber ? "#" + hexNumber : false
    }

    renderOverviewGroupsLegends() {
        const project = prosConnect.getActiveProject()
        const title = project.getRbTagTitles()[this.chosenBgIndex]
        let mvTag = project.getMvTagSettings(this.chosenBgIndex)
        if (!mvTag) {
            return null
        }
        let legendOptions = mvTag.options
            .filter(option => option.inUse && this.getBgColorByTagValue(option.optionIndex))
        if (legendOptions.length < 1) return null
        let hasAutoColor = false
        return <div className={"slab legend-container"}>
                <div className={"box-legend"}>
                    <h3>{title}</h3>
                    <ul>
                        {legendOptions.map(option => {
                            hasAutoColor = option.color === STR_NO
                            return <li key={'legenditem__' + option.optionIndex}>
                                    <span
                                        className={"tag"}
                                        style={{backgroundColor: this.getBgColorByTagValue(option.optionIndex)}}
                                    >{hasAutoColor ? <span>A</span> : null}
                                    </span>
                                    {option.label}
                                </li>
                        })}
                    </ul>
                    {hasAutoColor
                        && <><Spacer line/><p><span className={"tag"}><span>A</span></span> Automaattinen väri</p></>}
                </div>
            </div>
    }

    // Now depends on selected date expiration or creation
    checkOrRenderObsWithoutDueDate(renderElements = false){
        if(!this.props.uiList) return
        let obsList = []
        let obsNoTimeListAll = []
        this.props.uiList.forEach((report, i) => {
            const obsNoTimeList = this.returnObsListWoTime(report[OBS_LIST])
            obsNoTimeListAll.push(...obsNoTimeList)
            if (report.hasOwnProperty(OBS_LIST) && obsNoTimeList.length > 0) {
                if(renderElements){
                    obsList.push(<div
                        key={report[ATTR_OBJ_ID]}
                    ><h3>{report.text} {obsNoTimeList.length > 1 ? "(" + obsNoTimeList.length + ")" : ''}</h3>
                        <div className={"element-set flex-wrap"}>
                            {this.returnObsListWithoutUtc(obsNoTimeList)}
                        </div>
                    </div>)
                }else{
                    obsList = obsNoTimeListAll
                }
            }
        })
        return obsList
    }

    renderShowBottomPanelButton(){
        if(this.checkOrRenderObsWithoutDueDate().length < 1) return null
        return <BasicButton
            btnClass={"2nd"}
            label={"Näytä määräajattomat kirjaukset (" + this.checkOrRenderObsWithoutDueDate().length + ")"}
            icon={"calendar-none"}
            action={()=>this.toggleBottomPanel()}
            className={"margin-top"}
        />
    }

    renderScheduleMatrixTable() {
        const isAnyOverviewMode = this.scheduleMatrixViewMode !== scheduleMatrixViewModeType.NORMAL_ITEMS
        return <>
                <section className={"table-view " + (isAnyOverviewMode ?
                    "schedule-matrix-table-view overview-mode" : "schedule-matrix-table-view")
                    + (this.scheduleMatrixViewMode === scheduleMatrixViewModeType.OVERVIEW_GROUPS ? " overview-mode-timeline" : "")
                    + (this.state.showPrevNextHistory ? " schedule-matrix-table-history" : "")
                }>
                {this.renderMatrix()}
                {this.renderObsWithoutUtc()}
                {this.renderOverviewGroupsLegends()}
                {
                    this.props.viewMode && this.props.viewMode === VIEW_MODE_KANBAN
                    ? null
                    : this.renderShowBottomPanelButton()
                }
            </section>
            <SidePanel
                show={this.state.showSidepanel}
                closeCallback={()=> this.closeSidepanel()}
            >
                {this.renderChosenObs()}
            </SidePanel>
        </>
    }

    goToPresentTime() {
        this.changeBrowsingTime(0);
    }

    renderChosenObs() {
        if (!this.state.chosenObsList) {
            return null
        }
        return this.state.chosenObsList.map(
            (report) => <RenderReport
                key={report[ATTR_OBJ_ID]}
                report={report}
                refreshParentUi={this.refreshUi}
                // tableViewStateFromParent={true}
                notif={this.notifFromReport}
                gotoPage={this.gotoPage}
                isObsSidePanel={true}
                onSelectObs={newObsId=>{
                    this.props.onSelectObs(newObsId)
                }}
            />
        )
    }

    gotoPage(page) {
        this.props.history.push(page)
    }

    render() {
        require("./assets/scss/ScheduleMatrix.scss");
        let project = prosConnect.getActiveProject();
        if (!project) {
            return <h1>Valitse projekti</h1>
        }
        if (!this.uiActorList || !this.columns) {
            return null;
        }
        if (prosConnect.getActiveProject().getRbTags().length <= 0) {
            return <div className={"msg msg-info"}><h3>Osaprojektilla ei ole monivalintoja - ei voi näyttää {this.props.viewMode === VIEW_MODE_KANBAN ? 'kanban näkymää' : 'kalenteria'}</h3></div>
        }
        return <>
            {this.renderScheduleMatrixTable()}
            {prosPopupRender(this, "ScheduleMatrix")}
        </>
    }
}
